<template>
    <div>
        <md-dialog id="md-dialog" :md-active.sync="showDialog" :md-fullscreen="true" @md-opened="setDefault" @md-closed="clearData">
            <md-dialog-title style="">
                <label style="line-height: 40px;">Browse Products</label>
                <md-button class="md-icon-button" @click="onClosedialog" style="float: right;"><md-icon style="font-size: 35px!important;">close</md-icon></md-button>
            </md-dialog-title>
            <md-dialog-content>
                <div class="md-layout md-gutter md-size-100">
                    <div class="md-layout-item md-size-25">
                        <md-field md-inline >
                            <md-input placeholder="Search Products" v-model="keyword" @input="inputSearch"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-25">
                        <md-field>
                            <md-select placeholder="Group" v-model="groupsMode" @md-selected="mdSelectedgroups">
                                <md-option value="">Please Select Group</md-option>
                                <md-option v-for="item in groups" :key="item.code" :value="item.code">{{item.code}}:{{item.title}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-25">
                        <md-field>
                            <md-select placeholder="Sub Group" v-model="subgroupsMode" @md-selected="mdSelectedsubgroups(subgroupsMode)" v-bind:disabled="(groupsMode == ''||groupsMode == null) ? true : false">
                                <md-option value="">Please Select Sub Group</md-option>
                                <md-option v-for="item in subgroups" :key="item.code" :value="item.code">{{item.code}}:{{item.title}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-25">
                        <md-field>
                            <md-select placeholder="CG" v-model="cggroupsMode" @md-selected="searchOnTableResult" v-bind:disabled="(subgroupsMode == '' || subgroupsMode == null) ? true : false">
                                <md-option value="">Please Select Sub Group</md-option>
                                <md-option v-for="item in cggroups" :key="item.code" :value="item.code">{{item.code}}:{{item.title}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
                <div class="md-layout md-size-100">
                    <div class="md-layout-item md-size-50">
                        <md-content class="md-content-1">
                            <div class="md-layout md-gutter" v-if="probrowse.length === 0">
                                <div class="md-layout-item md-layout-item-1">
                                    <span class="span-1">
                                        Search for products using search or selecting <br>
                                        from dropdown
                                    </span>
                                </div>
                            </div>
                            <div class="md-layout md-gutter" v-if="probrowse.length > 0">
                                <div class="md-layout-item">
                                    <span class="span-2">Search Results</span>
                                </div>
                                <div class="md-layout-item">
                                    <span class="span-2" style="float:right;">
                                        <md-switch v-model="limit_search" class="md-primary">Limit</md-switch>
                                    </span>
                                </div>
                            </div>
                            <!-- <div class="md-layout md-gutter md-size-50"> -->
                            <div class="md-layout md-gutter md-size-50">
                                <div class="md-layout-item">
                                    <div v-if="probrowse.length !== 0">
                                        <md-table  class="dialog-product-table">
                                            <md-table-row>
                                                <md-table-head><md-checkbox style="margin-left:3px;margin-top: 5px;" v-model="checkAll" @change="selectAll"></md-checkbox></md-table-head>
                                                <md-table-head>Code</md-table-head>
                                                <md-table-head>Description</md-table-head>
                                                <md-table-head>Unit</md-table-head>
                                            </md-table-row>
                                            <md-table-row v-for="(item,index) in probrowse" :key="index">
                                                <md-table-cell><md-checkbox v-model="selectedProbrowse" :value="item.code" @change="onSelectData(item.code,$event,item)"></md-checkbox></md-table-cell> 
                                                <md-table-cell><div>{{ item.code }}</div></md-table-cell>
                                                <md-table-cell><div>{{ item.title_th }}</div></md-table-cell>
                                                <md-table-cell><div>{{ unitmaster[item.selling_um] }}</div></md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </div>
                                </div>
                            </div>
                        </md-content>
                    </div>
                    <div class="md-layout-item md-size-50">
                        <md-content class="md-content-2">
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item">
                                    <span class="span-1">Selected for Import</span>
                                </div>
                                <div class="md-layout-item">
                                    <span class="span-2">{{productIm.length}} ITEMS SELECTED</span>
                                </div>
                            </div>
                            <div class="md-layout md-gutter" v-if="productIm.length === 0">
                                <div class="md-layout-item md-layout-item-1">
                                    <span class="span-3">
                                        No products selected for import <br>
                                        Please select items from search results
                                    </span>
                                </div>
                            </div>
                            <div class="md-layout md-gutter" v-if="productIm.length > 0">
                                <div class="md-layout-item">
                                    <div v-if="productIm.length !== 0">
                                        <!-- <datatableImprt :unitmaster="unitmaster" v-on:import="addImportProduct"></datatableImprt> -->
                                        <md-table class="dialog-product-table">
                                            <md-table-row>
                                                <md-table-head id="selectAll"></md-table-head>
                                                <!-- <md-table-head><input type="checkbox" v-model="checkAll" @click="selectAll"></md-table-head> -->
                                                <md-table-head>Code</md-table-head>
                                                <md-table-head>Description</md-table-head>
                                                <md-table-head>Unit</md-table-head>
                                            </md-table-row>
                                            <md-table-row  md-selectable="multiple" md-auto-select v-for="(item,index) in productIm" :key="index">
                                                <!-- <md-table-cell><md-checkbox v-model="selectedData" :value="item" v-on:click.native="onSelectData(selectedData)"></md-checkbox></md-table-cell> -->
                                                <md-table-cell>
                                                    <md-button class="md-icon-button" md-menu-trigger @click="removeItem(item,index)">
                                                        <md-icon>delete</md-icon>
                                                    </md-button>
                                                </md-table-cell>
                                                <!-- <md-table-cell><input type="checkbox" :value="item" v-model="selected"></md-table-cell> -->
                                                <md-table-cell>{{ item.code }}</md-table-cell>
                                                <md-table-cell>{{ item.title_th }}</md-table-cell>
                                                <md-table-cell>{{ unitmaster[item.selling_um] }}</md-table-cell>
                                            </md-table-row>
                                        </md-table>
                                    </div>
                                </div>
                            </div>
                        </md-content>
                    </div>
                </div>
            </md-dialog-content>
            <md-dialog-actions>
                <md-content class="md-content-3">
                    <md-button @click="showDialog = false">Cancel</md-button>
                    <md-button class="md-primary" @click="onImportproduct">Import</md-button>
                </md-content>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>


// import CipherService from "@/services/cipher";
import ProductService from "@/services/product";

// var _ = require('lodash');

export default {
    name: 'dialogImportProduct',
    props:{
        productsImport: {
            type: Array
        }
    },
    data(){
        return {
            showDialog: false,
            checkAll: true,
            keyword: "",
            groupsMode: "",
            subgroupsMode: "",
            cggroupsMode: "",
            
            probrowse: [],
            probrowseImport: [],

            groups:[],
            subgroups:[],
            cggroups:[],

            selectedProbrowse: [],
            limit_search: true,

        }
    },
    computed:{

       productIm: {
            get: function () {
                return this.productsImport;
                // console.log('compute', this.selectedProbrowse);
            },
            set: function(){

            }
       },
        unitmaster(){
            // console.log(this.$store.getters['cpcreate/unitmaster'])
            return this.$store.getters['cpcreate/unitmaster']
        }
    },
    watch:{
        // checkAll(){
            
        // }
    },
    mounted(){
    
    },
    created(){

         ProductService.getGroups()
            .then(response => {
                this.groups = response;
            });

            this.$store.dispatch('cpcreate/getUnitMaster')
    },
    methods:{
        clearData(){
            // console.log('clear data')
            this.keyword = '';
            this.groupsMode = '';
            this.subgroupsMode = '';
            this.cggroupsMode = '';
            this.probrowse = [];
        },
        setDefault(){
            // this.$nextTick(() => {
			    this.probrowse = [];
            // });
            // this.probrowse = [];
            this.selectedProbrowse = [];
            for(let i = 0; i < this.productIm.length;i++)
            {
                this.selectedProbrowse.push(this.productIm[i].code);
            }
        },
        removeItem(item,index){

            this.productIm.splice(index,1)

            let idx = this.selectedProbrowse.indexOf(item.code);
            this.selectedProbrowse.splice(idx,1);

            //console.log(this.selectedProbrowse)
        },
        onClosedialog(){
            this.showDialog = false;
        },
        onImportproduct(){

            if(this.productIm.length < 1)
            {
                alert('Please select at least one item.')
                return;
            }

            this.$emit('importProduct', this.productIm)
            this.showDialog = false;
            
        },
        mdSelectedgroups(groups){
            // console.log('select group')
            this.subgroupsMode = ''
            this.cggroupsMode = ''

            ProductService.getSubgroups(groups)
            .then(response => {
                this.subgroups = response;
                this.searchOnTableResult()
            });

        },
        mdSelectedsubgroups(subgroup){
            this.cggroupsMode = ''
            if(subgroup){
                ProductService
                .getSubgroups(subgroup)
                .then(response => {
                    this.cggroups = response;

                    this.searchOnTableResult()
                });
            }else{
                this.searchOnTableResult()
            }

        },
        inputSearch(key){
            // console.log(key);
            if(key.length < 4 ) return;
                this.searchOnTableResult();
            // else{}
        },
        searchOnTableResult () {
            this.checkAll = false;
            var num = this.keyword.length;

            if (this.keyword == "" && this.groupsMode == "" && this.subgroupsMode == "" && this.cggroupsMode == "")
             {
                  this.probrowse = [];
                 return;
             }

            // if(this.keyword != "")
            // {
                // if(num < 4 ) {
                //     this.probrowse = [];
                //     return;
                // }
            // }
            //  if(num < 4 ) {
            //      this.probrowse = [];
            //      return;
            //  }
            //this.skip = 0
            //if(num > 1 || this.groupsMode || this.subgroupsMode || this.cggroupsMode){
            // if(num > 1){
                let keyword = {
                    'skip':this.skip,
                    //'limit':10,
                    'keyword':this.keyword,
                    'groupsMode': this.groupsMode,
                    'subgroupsMode': this.subgroupsMode,
                    'cggroupsMode': this.cggroupsMode,
                    'loading': 0};

                if(this.limit_search == true) keyword.limit = 20;
                else  keyword.limit = 100;

                ProductService.getProductBrowse(keyword)
                    .then(response => {
                        this.probrowse = response;
                        //console.log(response);
                    });

            // }
        },
        checkDeleteCheckbox(code, object) {
            var del = true;
            for (var i = 0; i < object.length; i++) {
                if (object[i] == code) {
                    del = false;
                }
            }
            return del; // if return true delete
        },

        onSelectData(code,event,item){
            if(this.checkDeleteCheckbox(code, event)){ // add
                for(let i =0;i < this.productIm.length; i++){
                    if(this.productIm[i].code == code) {
                        this.productIm.splice(i,1);
                    }
                }

            }else{ // remove
                this.productIm.push(item);
            }
        },
        selectAll(){
            if(this.checkAll == true){
                for(let i = 0; i < this.probrowse.length; i++)
                {
                    if(this.selectedProbrowse.indexOf(this.probrowse[i].code) === -1)
                        this.selectedProbrowse.push(this.probrowse[i].code)
                    var _self = this;
                    var found = this.productIm.find(function (obj) { return obj.code === _self.probrowse[i].code; });

                    if(!found) this.productIm.push(this.probrowse[i])

                    // for(let j = 0; j < this.productIm.length; j++){
                    //     if(this.probrowse[i].code == this.productIm[j].code)
                    //     {
                    //         this.productIm[j].splice(j,1);
                    //     }
                    // }
                        
                }
            }else{
                //this.selectedProbrowse = [];
                for(let i = 0; i < this.probrowse.length; i++)
                {
                    let idx = this.selectedProbrowse.indexOf(this.probrowse[i].code)
                    this.selectedProbrowse.splice(idx,1)

                    for(let j = 0; j < this.productIm.length; j++){
                        if(this.probrowse[i].code == this.productIm[j].code)
                        {
                            this.productIm.splice(j,1);
                        }
                    }
                    //if(this.selectedProbrowse.indexOf(this.probrowse[i].code) === -1)
                    //    this.selectedProbrowse.push(this.probrowse[i].code)
                }
            }

            // console.log(this.selectedProbrowse);
        }

    }
}
</script>

<style lang="scss" scoped>
.dialog-product-table{
    height: 200px;
}
</style>